// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2AhAh","header":"ClearentDisclaimer_header__LsSBG","inner":"ClearentDisclaimer_inner__2VI9p"};